import { useState } from 'react';

let toastId = 0;

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = (message, type = 'success', duration = 3000) => {
    const id = toastId++;
    const newToast = { id, message, type, duration };

    setToasts(prevToasts => [...prevToasts, newToast]);
  };

  const removeToast = (id) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  };

  const showSuccess = (message, duration = 3000) => {
    addToast(message, 'success', duration);
  };

  const showError = (message, duration = 4000) => {
    addToast(message, 'error', duration);
  };

  const showWarning = (message, duration = 3500) => {
    addToast(message, 'warning', duration);
  };

  const showInfo = (message, duration = 3000) => {
    addToast(message, 'info', duration);
  };

  return {
    toasts,
    removeToast,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};